import moment from 'moment'

export function timeAgo(date) {
    return moment(date).fromNow()
}

export function isAfter(targetDate, comparableDate) {
    return moment(targetDate).isAfter(comparableDate)
}
